import React, { useEffect, useState } from "react";
import { getData, postData } from '../middleware/apiMiddleware';
import s from './ItemSection.module.css';
import { useNavigate } from "react-router-dom";
import { SectionList } from '../middleware/MyConstant';

export default function ItemSection(prop) {	
  const navigate = useNavigate();
  const itemId = prop.itemId;

  // ✅ Fixed: State holds single value (string/null) instead of array (matches "only one can be chosen" requirement)
  const [selectedSection, setSelectedSection] = useState(null); 

  // Fetch current selected section (item's section can be null)
  const fetchData = async () => {
    try {
      const res = await getData(`item/getSection?itemId=${itemId}`, navigate);
      // Set to the section value (or null if not exists)
      setSelectedSection(res.data.section ?? null); 
    } catch (error) {
      console.error("Failed to fetch section:", error);
    }
  };

  // Update section (supports setting to null to clear selection)
  const updateSection = async (newSection) => {
    try {
      const obj = { itemId, section: newSection };
      await postData("item/updateSection", obj, navigate);
      fetchData(); // Refresh after update
    } catch (error) {
      console.error("Failed to update section:", error);
      alert(`Could not ${newSection ? 'select' : 'clear'} section. Please try again.`);
    }
  };

  // Initial data fetch
  useEffect(() => {
    if (itemId) fetchData();
  }, [itemId]);

  return (
    <div className={s.container}>
      <h3 className={s.sectionTitle}>Item Section</h3>

      {/* Current Selected Section */}
      <div className={s.selectedSection}>
        <h4 className={s.subtitle}>Current Section:</h4>
        {selectedSection ? (
          <div className={s.selectedTag}>
            <span className={s.tagText}>{selectedSection}</span>
            <button
              className={s.removeButton}
              onClick={() => updateSection(null)} // Clear to null
              aria-label={`Remove section ${selectedSection}`}
            >
              ×
            </button>
          </div>
        ) : (
          <span className={s.emptyText}>No section selected (can be null)</span>
        )}
      </div>

      {/* Available Sections (Single Selection) */}
      <div className={s.availableSection}>
        <h4 className={s.subtitle}>Select a Section (Only One):</h4>
        <div className={s.availableButtons}>
          {SectionList.map((sectionOption) => (
            <button
              key={sectionOption}
              className={`${s.sectionButton} ${selectedSection === sectionOption ? s.selectedButton : ''}`}
              onClick={() => updateSection(sectionOption)}
            >
              {sectionOption}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}